import { useState } from 'react'

const useTableControls = (
  initialSort = [{ field: 'createdAt', sort: 'desc' }],
  initialPaginationModel = { page: 0, pageSize: 10 },
) => {
  const [paginationModel, setPaginationModel] = useState(initialPaginationModel)
  const [sortModel, setSortModel] = useState(initialSort)
  const [filterModel, setFilterModel] = useState({ items: [] })

  const reset = () => {
    setPaginationModel(initialPaginationModel)
    setSortModel(initialSort)
    setFilterModel({ items: [] })
  }

  return {
    paginationModel,
    setPaginationModel,
    sortModel,
    setSortModel,
    filterModel,
    setFilterModel,
    reset,
  }
}

export default useTableControls
